// Mock data for Manish Labchem Pvt. Ltd. - B2B Chemical Manufacturer

export const company = {
  name: "Manish Labchem",
  legalName: "Manish Labchem Pvt. Ltd.",
  shortName: "Manish Labchem",
  brandMark: "ML",
  tagline: "Pure Acids. Industrial Strength.",
  role: "Manufacturer, Supplier & Repacker",
  established: 1999,
  yearsExperience: 27,
  certification: "ISO 9001:2015 Certified",
  phone: "+91 98982 50907",
  phoneAlt: "+91 98253 12087",
  email: "manishlabchem@yahoo.com",
  emailAlt: "manishlabchem@yahoo.com",
  address: {
    line1: "Plot No. 201/B, Phase 2, GIDC",
    line2: "Vapi",
    state: "Gujarat 396195, India"
  },
  hours: "Mon – Sat: 9:00 AM – 7:00 PM",
  whatsapp: "919898250907"
};

export const stats = [
  { value: "27+", label: "Years of Expertise" },
  { value: "500+", label: "Industrial Clients" },
  { value: "20K+", label: "MT Annual Supply" },
  { value: "15+", label: "States Served" }
];

export const products = [
  {
    slug: "hydrochloric-acid",
    name: "Hydrochloric Acid",
    formula: "HCl",
    short: "Premium-grade HCl available in Commercial, C.P., L.R. and A.R. grades for industrial, pharma and lab applications.",
    grades: ["C.P. Grade", "L.R. Grade", "A.R. Grade"],
    concentration: "30% – 35%",
    packaging: "40 Kg HDPE Carboys, 250 Kg HDPE Drums, Tankers (10–36 MT)",
    appearance: "Pale yellow to colourless liquid",
    image: "/images/hcl-v3.jpg",
    applications: ["Steel pickling & metal cleaning", "PVC manufacturing", "Pharmaceutical synthesis", "Water treatment & pH control", "Ore processing & leather tanning"]
  },
  {
    slug: "sulphuric-acid",
    name: "Sulphuric Acid",
    formula: "H₂SO₄",
    short: "Industrial-grade sulphuric acid manufactured to consistent strength — supplied to battery, refinery, mining and process-chemistry plants nationwide.",
    grades: ["C.P. Grade", "L.R. Grade", "A.R. Grade"],
    concentration: "98% – 98.5%",
    packaging: "40 Kg Carboys, 260 Kg HDPE Drums, Tankers (10–36 MT)",
    appearance: "Clear, colourless, oily liquid",
    image: "/images/h2so4-v3.jpg",
    applications: ["Fertilizer manufacturing", "Dye & pigment production", "Detergents & soaps", "Battery electrolyte", "Petroleum refining"]
  },
  {
    slug: "nitric-acid",
    name: "Nitric Acid",
    formula: "HNO₃",
    short: "Strong, high-purity nitric acid used in fertilizers, explosives, dye intermediates and metal etching.",
    grades: ["C.P. Grade", "L.R. Grade", "A.R. Grade"],
    concentration: "60% – 70%",
    packaging: "40 Kg Carboys, 250 Kg HDPE Drums, Tankers (10–36 MT)",
    appearance: "Colourless to pale yellow liquid",
    image: "/images/hno3-v3.jpg",
    applications: ["Fertilizers (ammonium nitrate)", "Dye intermediates", "Metal etching & passivation", "Pharmaceutical synthesis", "Explosives manufacturing"]
  },
  {
    slug: "calcium-chloride",
    name: "Calcium Chloride",
    formula: "CaCl₂",
    short: "Anhydrous and dihydrate calcium chloride for oil drilling, de-icing, food processing and dust control.",
    grades: ["Anhydrous (94–97%)", "Dihydrate Flakes", "Food Grade"],
    concentration: "77% – 97%",
    packaging: "25 Kg & 50 Kg HDPE Bags, 1 Ton Jumbo Bags",
    appearance: "White granules / flakes / powder",
    image: "/images/cacl2-v2.jpg",
    applications: ["Oil & gas drilling fluids", "De-icing & dust control", "Concrete acceleration", "Food preservation", "Refrigeration brines"]
  },
  {
    slug: "sodium-hypochlorite",
    name: "Sodium Hypochlorite",
    formula: "NaOCl",
    short: "Industrial-grade sodium hypochlorite for water disinfection, bleaching and large-scale sanitation applications.",
    grades: ["Technical Grade"],
    concentration: "4% – 12% available chlorine",
    packaging: "40 Kg Carboys, 250 Kg HDPE Drums, Tankers (10–36 MT)",
    appearance: "Pale greenish-yellow liquid",
    image: "/images/naocl.jpg",
    applications: ["Water & sewage treatment", "Textile bleaching", "Pulp & paper industry", "Disinfection (hospitals, dairy)", "Industrial sanitation"]
  }
];

export const industries = [
  { name: "Oil & Gas (ONGC)", icon: "Fuel", desc: "Drilling fluid acids, well stimulation and refinery process chemistry." },
  { name: "Power & Energy (BHEL)", icon: "Zap", desc: "Boiler-water dosing, battery electrolyte and turbine cleaning acids." },
  { name: "Defence & Strategic", icon: "Shield", desc: "MIL-spec grade chemicals for ordnance, propellants and metal preparation." },
  { name: "Atomic Energy & Research", icon: "Atom", desc: "Ultra-pure A.R. grade acids for nuclear, propellant and aerospace research." },
  { name: "Steel & Metallurgy", icon: "Factory", desc: "Pickling, cleaning, passivation & surface treatment chemistry." },
  { name: "Pharmaceuticals", icon: "Pill", desc: "IP/BP/USP grade chemicals for API and formulation plants." },
  { name: "Railways & Infrastructure", icon: "TramFront", desc: "Track maintenance, yard sanitation and large-scale infrastructure chemistry." },
  { name: "Textiles, Dyes & Paper", icon: "Shirt", desc: "Bleaching, dyeing, finishing and pulp processing chemistry." },
  { name: "Research & Laboratories", icon: "FlaskConical", desc: "A.R. & L.R. grade reagents for analytical and QC laboratories." }
];

export const whyUs = [
  { icon: "ShieldCheck", title: "ISO 9001:2015 Quality", desc: "Every batch is tested in-house against IS, BP and IP standards before dispatch." },
  { icon: "Truck", title: "Pan-India Logistics", desc: "Own and partner tanker fleet delivering across Gujarat, Maharashtra & 12+ states." },
  { icon: "FlaskConical", title: "Multi-Grade Production", desc: "From commercial to A.R. grade — one supplier for all your purity needs." },
  { icon: "Clock", title: "27+ Years of Trust", desc: "Nearly three decades of uninterrupted supply to India’s leading chemical & pharma names." },
  { icon: "BadgeCheck", title: "Transparent Pricing", desc: "Direct from manufacturer — no middlemen, competitive contract & spot rates." },
  { icon: "Headphones", title: "Dedicated Support", desc: "Single-point technical & sales contact for every key account." }
];

export const certifications = [
  { code: "ISO 9001:2015", body: "Quality Management System" },
  { code: "GeM Registered", body: "Government e-Marketplace Seller" },
  { code: "GPCB Approved", body: "Gujarat Pollution Control Board" },
  { code: "MSME Registered", body: "Ministry of MSME, Govt. of India" },
  { code: "GST Compliant", body: "24AABCA1234X1Z9" },
  { code: "IEC Certified", body: "Import Export Code Holder" },
  { code: "Responsible Care", body: "Member – Indian Chemical Council" }
];

export const testimonials = [
  {
    name: "Rakesh Mehta",
    role: "Procurement Head",
    company: "Sunrise Pharma Ltd., Ankleshwar",
    quote: "We have sourced HCl and Nitric Acid from Manish Labchem for over 8 years. Consistent purity, on-time tankers and prompt CoAs — they make our QA team’s job easier."
  },
  {
    name: "Anita Deshpande",
    role: "Plant Manager",
    company: "Konkan Textile Mills, Boisar",
    quote: "Their sodium hypochlorite quality is rock-solid. We switched from three vendors to a single Manish Labchem contract and our bleaching costs dropped by 11%."
  },
  {
    name: "Vikram Shah",
    role: "Director",
    company: "Patel Steel Pickling Pvt. Ltd., Silvassa",
    quote: "Tanker discipline is impeccable. In 5 years we have not faced a single delivery delay or off-spec batch. Highly recommended for steel pickling lines."
  }
];

export const faqs = [
  {
    q: "What is the minimum order quantity (MOQ)?",
    a: "For drum/carboy packs the MOQ is 40 Kg. For tanker dispatch the minimum is 18 MT. Lab-grade reagents (A.R./L.R.) start at 5 Kg."
  },
  {
    q: "Do you ship outside Gujarat?",
    a: "Yes. We regularly deliver across Maharashtra, MP, Rajasthan, Karnataka, Tamil Nadu, Telangana and Delhi-NCR via our partner tanker fleet."
  },
  {
    q: "Will I receive a Certificate of Analysis (CoA) and MSDS?",
    a: "Every consignment is dispatched with a batch-specific CoA, MSDS, GST invoice and e-way bill. Digital copies are emailed in advance."
  },
  {
    q: "How quickly can you dispatch an urgent order?",
    a: "For stocked grades we can dispatch within 24 hours from PO confirmation. Made-to-spec batches typically require 3–5 working days."
  },
  {
    q: "Do you offer long-term supply contracts?",
    a: "Yes — we offer 6 and 12 month contract pricing with locked rates and priority allocation for committed volumes."
  },
  {
    q: "Are your products suitable for pharmaceutical use?",
    a: "Our C.P., L.R. and A.R. grades meet IP/BP/USP specifications and are used by listed pharma companies across India."
  }
];

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Process", href: "#process" },
  { label: "Industries", href: "#industries" },
  { label: "Quality", href: "#quality" },
  { label: "Contact", href: "#contact" }
];
